import type { ReactNode } from 'react'
import { InfoHint } from './InfoHint'

export interface MetricProps {
  label: ReactNode
  value: ReactNode
  foot?: ReactNode
  icon: ReactNode
  tone?: 'accent' | 'pos' | 'info' | 'muted'
  title?: string
  hint?: ReactNode
}

/** Карточка-метрика (общая для парсера и «Авто-бота»): иконка + значение + подпись + (!). */
export function Metric({ label, value, foot, icon, tone = 'accent', title, hint }: MetricProps) {
  const iconCls = tone === 'accent' ? 'metric__icon' : `metric__icon metric__icon--${tone}`
  return (
    <div className="card metric" title={title}>
      <div className="metric__head">
        <span className="metric__label">
          {label}
          {hint ? <InfoHint text={hint} /> : null}
        </span>
        <span className={iconCls}>{icon}</span>
      </div>
      <div className="metric__value tnum">{value}</div>
      {foot ? <div className="metric__foot">{foot}</div> : null}
    </div>
  )
}
